import { render } from "./ModalInputCredits.vue?vue&type=template&id=3fa79c8f&scoped=true"
import script from "./ModalInputCredits.vue?vue&type=script&lang=js"
export * from "./ModalInputCredits.vue?vue&type=script&lang=js"

import "./ModalInputCredits.vue?vue&type=style&index=0&id=3fa79c8f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa79c8f"]])

export default __exports__